var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRupeefill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4335_35460)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 12C9.31371 12 12 9.31371 12 6C12 2.68629 9.31371 0 6 0C2.68629 0 0 2.68629 0 6C0 9.31371 2.68629 12 6 12Z",
    fill: "#7DCC18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25255 4.47469H7.29065C7.24758 4.30172 7.17979 4.13841 7.08965 3.98984H8.25255C8.48686 3.98984 8.67679 3.7999 8.67679 3.5656C8.67679 3.33129 8.48686 3.14136 8.25255 3.14136H3.58589C3.35158 3.14136 3.16165 3.33129 3.16165 3.5656C3.16165 3.7999 3.35158 3.98984 3.58589 3.98984H5.58588C5.934 3.98984 6.23688 4.1866 6.38955 4.47469H3.58589C3.35158 4.47469 3.16165 4.66463 3.16165 4.89894C3.16165 5.13324 3.35158 5.32318 3.58589 5.32318H6.38955C6.23686 5.61125 5.934 5.80803 5.58588 5.80803H3.58589C3.4143 5.80803 3.25961 5.91141 3.19392 6.0699C3.12827 6.22845 3.16455 6.41091 3.28589 6.53225L6.61922 9.86558C6.70209 9.9484 6.81061 9.98982 6.91922 9.98982C7.02778 9.98982 7.13634 9.9484 7.21922 9.86558C7.38492 9.69987 7.38492 9.43128 7.21922 9.26558L4.61013 6.65649H5.58588C6.40875 6.65649 7.10107 6.08797 7.29138 5.32315H8.25255C8.48686 5.32315 8.67679 5.13322 8.67679 4.89891C8.67679 4.66463 8.48686 4.47469 8.25255 4.47469Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4335_35460"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeefill);
export default __webpack_public_path__ + "static/media/rupeefill.c4987a7591f796831f5ada94da5fe755.svg";
export { ForwardRef as ReactComponent };